import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { formatToZMW, sumOfArray } from "../../../helpers";

const DetailedIncomeStatement = ({ rdata }) => {
  const [incomeStatementData, setIncomeStatementData] = useState([]);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [netIncome, setNetIncome] = useState(0);

  const allData = useOutletContext();

  useEffect(() => {
    const fetchData = () => {
      const data = [];
      let revenueTotal = 0;
      let expensesTotal = 0;
      

      // Process bills as revenue
      rdata.bills.forEach((res) => {
        const coa = allData.budget?.find((b) => b.id === res.coa_id)?.coa || "Unknown";
        const amount = parseFloat(res.amount);
        data.push({ name: allData.coa?.find(item => item.account === coa)?.name, amount, type: "revenue" });
        revenueTotal += amount;
      });

      // Process suppliers as expenses
      rdata.supplier
        .filter((a) => a.type == 1)
        .forEach((res) => {
        //   const fromCoa = sumOfArray(
        //     rdata.journal
        //       .filter((a) => a.from_coa === res.coa)
        //       .map((entry) => parseFloat(entry.amount))
        //   );
        //   const toCoa = sumOfArray(
        //     rdata.journal
        //       .filter((a) => a.to_coa === res.coa)
        //       .map((entry) => parseFloat(entry.amount))
        //   );
        
        const coa = allData.budget?.find((b) => b.id === res.coa)?.coa;
        
        //   const amount = parseFloat(res.amount) - fromCoa + toCoa;
        if(coa[0] == 2){
            const amount = parseFloat(res.amount);
            data.push({ name: allData.coa?.find(item => item.account === coa)?.name, amount, type: "expense" });
            expensesTotal += amount;
        }         
        });

      setIncomeStatementData(data);
      setTotalRevenue(revenueTotal);
      setTotalExpenses(expensesTotal);
      setNetIncome(revenueTotal - expensesTotal);
    };

    fetchData();
  }, []);

  const formatAmount = (amount) => formatToZMW(amount.toFixed(2));

  return (
    <div className="w-full">
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Income Statement</h1>
        <table id="detailed-income-statement" className="w-full g-table">
          <thead className="bg-blue-900 text-white">
            <tr className="">
              <th className="text-left py-2 px-2">Item</th>
              <th className="text-left py-2 px-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* Render Revenue Section */}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="py-2 px-2">Revenue</td>
              <td className="py-2 px-2"></td>
            </tr>
            {incomeStatementData
              .filter((item) => item.type === "revenue")
              .map((item, index) => (
                <tr key={`revenue-${index}`}>
                  <td>{item.name}</td>
                  <td>{formatAmount(item.amount)}</td>
                </tr>
              ))}
            <tr className="bg-blue-900 text-white">
              <td className="py-2 px-2">Total Revenue</td>
              <td className="py-2 px-2">{formatAmount(totalRevenue)}</td>
            </tr>

            {/* Render Expense Section */}
            <tr className="bg-gray-800 text-white font-bold">
              <td className="py-2 px-2">Expense</td>
              <td className="py-2 px-2"></td>
            </tr>
            {incomeStatementData
              .filter((item) => item.type === "expense")
              .map((item, index) => (
                <tr key={`expense-${index}`}>
                  <td>{item.name}</td>
                  <td>{formatAmount(item.amount)}</td>
                </tr>
              ))}
            <tr className="bg-blue-900 text-white">
              <td className="py-2 px-2">Total Expense</td>
              <td className="py-2 px-2">{formatAmount(totalExpenses)}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th className="text-left">Total Revenue</th>
              <th className="text-left" id="total-revenue">{formatAmount(totalRevenue)}</th>
            </tr>
            <tr className="text-left">
              <th>Total Expenses</th>
              <th id="total-expenses">{formatAmount(totalExpenses)}</th>
            </tr>
            <tr className="text-left">
              <th>Surplus(Deficit)</th>
              <th id="net-income">{formatAmount(netIncome)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default DetailedIncomeStatement;
